import { googleLogout } from "@react-oauth/google";
import React, { ReactNode, createContext, useEffect, useState } from "react";
import { useData } from "../hooks/useData";
import { useGoogleAuthentication } from "../hooks/useGoogleAuthentication";

export interface ILoginContext {
    type: ("google"),
    login: () => void,
    logout: () => void,
    loggedIn: boolean
}

export const LoginContext = createContext({
    type: "google",
    login: () => {},
    logout: () => {},
    loggedIn: false
} as ILoginContext);

interface Props {
    children: ReactNode
}

const LoginProvider : React.FC<Props> = ({children}) => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [loginToBackend] = useData(`user/login/google`, "GET", "application/json");
    const [logoutInBackend] = useData(`user/logout`, "GET", "application/json");
    const [verifyRoleApiCall] = useData<{granted: boolean}>(`user/verify/role?r=view_data`, "GET", "application/json");
    const [login] = useGoogleAuthentication((token) => {
        loginToBackend(() => {
            window.location.reload();
        }, () => {}, undefined, token);
    });

    useEffect(() => {
        verifyRoleApiCall((data) => setLoggedIn(data?.granted??false), (error) => console.log(error))
    }, [verifyRoleApiCall, setLoggedIn]);

    
    /*
    const login = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: (resp) => axios.post('https://oauth2.googleapis.com/token', resp).then(response => console.log(response)), // ,
        onError: () => {}
    });*/

    const logout = () => {
        logoutInBackend(() => {
            googleLogout();
            window.location.reload();
        }, () => {});
    }

    return <LoginContext.Provider value={{
        type: "google",
        login,
        logout,
        loggedIn
    }}>
        {children}
    </LoginContext.Provider>
}


export default LoginProvider;